import { render, staticRenderFns } from "./partnershipList.vue?vue&type=template&id=7b9173ce&scoped=true"
import script from "./partnershipList.vue?vue&type=script&lang=js"
export * from "./partnershipList.vue?vue&type=script&lang=js"
import style0 from "./partnershipList.vue?vue&type=style&index=0&id=7b9173ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9173ce",
  null
  
)

export default component.exports